import api from '@/api/axiosApi'

export async function fetchColumnOrder(planId: string): Promise<string[]> {
  const { data } = await api.get<string[]>(`/plans/${planId}/column-order`)
  return data
}

export async function updateColumnOrder(
  planId: string,
  columnOrder: string[]
): Promise<string[]> {
  const { data } = await api.put<string[]>(`/plans/${planId}/column-order`, {
    column_order: columnOrder,
  })
  return data
}
